import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import { isSignedInSelector } from "../../Security";

export default ({ component: Component, ...rest }) => {
  const isSignedIn = useSelector((state) => isSignedInSelector(state));

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isSignedIn === true) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/security/login",
                state: { referrer: props.location.pathname },
              }}
            />
          );
        }
      }}
    />
  );
};
